import { AggEventBody, SurveyViewEvent } from '@tm/types/embed/event'

let isSurveyStarted = false

/** Register survey view on mouse/touch/key events */
export const registerSurveyStartListener = (organizationId: string, surveyId: string) => {
  const listener = () => {
    // Do it once
    if (isSurveyStarted) return
    isSurveyStarted = true

    const event: AggEventBody = {
      // Change this if session is needed
      sid: 'session',
      organization_id: organizationId,
      url: window.location.toString(),
      events: [{ type: 'surveyView', survey_id: surveyId } as SurveyViewEvent],
    }

    try {
      void fetch(`${process.env.EMBED_API_DOMAIN}/agg-event`, {
        method: 'POST',
        headers: { 'Content-type': 'application/json' },
        body: JSON.stringify(event),
        mode: 'no-cors',
      })
    } catch (error) {
      // shut up
    }
  }

  const eventTypes: (keyof WindowEventMap)[] = ['touchmove', 'touchstart', 'mousemove', 'mousedown', 'keydown']

  eventTypes.forEach(eventType => window.addEventListener(eventType, listener))
}
